import React from 'react';
import '../App.css'
import './MainContentAreaAll.css'
function PersonalDetail(){
    return(
        <div className="Row">
        <div>   
           Name--Ravindrakumar Rasikbhai Patel<br/><br/>
           Email:ravi.asp.netdeveloper@gmail.com<br/><br/>
           Ph:2707232895<br/><br/>
           PreferredModeOfCommunication:Email<br/><br/>
           Work Authorization-  US--Citizen<br/><br/>
           Skype:live--cid.25341a63cc188838<br/><br/>
           linkedin:www.linkedin.com/in/ravindrakumar-patel<br/><br/>
           Current Location :104 plum creek Ct Apt 1D Elizabethtown Ky 42701<br/><br/>
           <b style={{textDecoration:'Underline'}}>Education</b><br/><br/>
           Collage ---Ahmedabad Institute of Technology, Ahmedabad<br/><br/>
           University---Gujarat Technology University ,Ahmedabad <br/><br/>
           Degree--  Bachelors of Computer Engineering <br/><br/>
           Duration--2007-2012<br/><br/>

        </div>
        </div>
    )
}
export default PersonalDetail